module.exports = __webpack_public_path__ + "img/spring_stretch2.prt.d6b21ecb.jpg";